<script setup lang="ts">
import type { Content } from "@prismicio/client";

defineProps(getSliceComponentProps<Content.IntroTextWithCtasSlice>());
</script>

<template>

  <Bounded
      as="header"
      y-padding="base"
      class="relative bg-primary-100"
  >
    <div class="text-primary font-medium text-xl">{{ slice.primary.eyebrow || "Meer info" }}</div>

    <div class="font-serif text-3xl max-w-5xl text-gray-800 leading-10">
      <PrismicText :field="slice.primary.description" />
    </div>


  </Bounded>

</template>
